import { API_HOST } from "@/App";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { z } from "zod";

const VivaTransactionSchema = z.object({
  status: z.enum(["PENDING", "COMPLETED", "FAILED"]),
  paymentId: z.string().optional(),
});

export const vivaTransactionOptions = (locationId: string, paymentId: string) =>
  queryOptions({
    queryKey: ["vivaTransaction"],
    queryFn: async () => {
      const response = await fetch(
        `${API_HOST}/v1/payments/${locationId}/viva/transaction/${paymentId}`
      );
      const data = await response.json();
      return VivaTransactionSchema.parse(data);
    },
    // refetchInterval: 2000,
    enabled: !!paymentId && !!locationId,
  });

export const useVivaTransaction = (locationId: string, paymentId: string) => {
  return useQuery(vivaTransactionOptions(locationId, paymentId));
};
